"use client";

import { useState } from "react";
import { CreateInboxWizard } from "./CreateInboxWizard";

type AddInboxDialogProps = {
  trigger?: React.ReactNode;
};

export const AddInboxDialog = ({ trigger }: AddInboxDialogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {trigger && <div onClick={() => setOpen(true)}>{trigger}</div>}
      <CreateInboxWizard isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
};
